import React from 'react'
import './continuedisable.css'

function ContinueDisabled({label = 'Continue'}) {
  return (
    <div className='btn-wrapper'>
        <span className='disable-btn'>{label}</span>
    </div>
  )
}

export default ContinueDisabled